'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('./utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _Plugin = require('./Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 扩展对象
 * 
 * @export
 * @class Extension
 */
var Extension = function () {
    /**
     * 创建一个扩展对象
     * 
     * @ignore
     * @param {string} id 扩展Id
     * @param {Object} data 扩展数据对象
     * @memberof Extension
     */
    function Extension(id, data) {
        (0, _classCallCheck3.default)(this, Extension);

        _Assert2.default.notEmpty('extensionId', id);
        _Assert2.default.notNull('extensionData', data);

        this._id = id;
        this._data = data;
    }

    /**
     * 获取注册扩展的插件
     * 
     * @type {Plugin}
     * @memberof Extension
     */


    (0, _createClass3.default)(Extension, [{
        key: 'owner',
        get: function get() {
            return this._owner;
        }

        /**
         * 设置注册扩展的插件
         * 
         * @type {Plugin}
         * @memberof Extension
         */
        ,
        set: function set(owner) {
            _Assert2.default.notNull('extensionOwner', owner);
            this._owner = owner;
        }

        /**
         * 扩展Id
         * 
         * @readonly
         * @memberof Extension
         */

    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }

        /**
         * 扩展数据
         * 
         * @readonly
         * @memberof Extension
         */

    }, {
        key: 'data',
        get: function get() {
            return this._data;
        }
    }]);
    return Extension;
}();

exports.default = Extension;
//# sourceMappingURL=Extension.js.map